<template>
  <div class="rate">
    <cube-rate
      v-model="defaultValue"
      :max="max"
      @input="handleInput"
    />
    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="data.fieldvalue"
      :data="data"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      defaultValue: 0
    }
  },
  computed: {
    max () {
      const { fieldconfig = {} } = this.data
      const { level = 7 } = fieldconfig
      return level
    }
  },
  mounted () {
    if (this.value) {
      this.defaultValue = parseInt(this.value)
    } else {
      if (this.data) {
        this.defaultValue = parseInt(this.data.fieldvalue)
      } else {
        this.defaultValue = 0
      }
    }
  },
  methods: {
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    handleInput (val) {
      this.data.fieldvalue = val
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="scss" scoped>
/* .rate {
  display: flex;
} */
.cube-rate {
  padding: 20px 0;
  ::v-deep .cube-rate-item {
    width: 16px;
    margin-right: 16px;
  }
}
</style>
